import { IFeatureFieldChange } from "./featureChange.types"

const FIELD_LABELS: Record<string, string> = {
  enabled: "Enabled",
  description: "Description",
  squad_name: "Team",
  deleted: "Deleted",
  name: "Name",
  created_at: "Created",
  id: "ID",
}

// Free-text fields read better as added/changed/removed with the text shown
// separately, rather than squeezed into an "old → new" line.
const TEXT_FIELDS = new Set(["description"])

const formatValue = (field: string, value: string | null): string => {
  if (value === null) return "—"
  if (field === "enabled") return value === "true" ? "On" : "Off"
  return value
}

const OPERATION_LABELS: Record<string, string> = {
  INSERT: "Created",
  UPDATE: "Updated",
  DELETE: "Deleted",
}

export const operationLabel = (operation: string): string =>
  OPERATION_LABELS[operation] ?? operation

export const fieldLabel = (field: string): string =>
  FIELD_LABELS[field] ?? field

/** One human-readable line per changed field, e.g. "Enabled: Off → On". */
export const describeFieldChange = ({
  field,
  oldValue,
  newValue,
}: IFeatureFieldChange): string => {
  const label = fieldLabel(field)

  if (TEXT_FIELDS.has(field)) {
    if (oldValue === null) return `${label}: added`
    if (newValue === null) return `${label}: removed`
    return `${label}: changed`
  }

  return `${label}: ${formatValue(field, oldValue)} → ${formatValue(field, newValue)}`
}

export const isTextFieldChange = ({ field }: IFeatureFieldChange): boolean =>
  TEXT_FIELDS.has(field)
